import { FlexRow } from '@csp/csp-web-ui';
import { FC } from 'react';
import { useSelector } from 'react-redux';
import { PermissionCheckComponent } from '../../../common/component/layout/PermissionCheckComponent';
import { BarcodeInputContainer } from '../../barcode-input/container/BarcodeInputContainer';
import { isLoggedInSelector } from '../../security/ducks/principalContextSelectors';
import { PermissionType } from '../../security/type/PermissionType';
import { SystemLinksDrawerContainer } from '../../system-links/container/SystemLinksDrawerContainer';
import { TechnicalSupportDrawerContainer } from '../../technical-support/container/TechnicalSupportDrawerContainer';
import { useCanViewMyProfile } from '../hooks/useCanViewMyProfile';
import { HeaderNavToolsBoxProps } from '../model/HeaderNavToolsBoxProps';
import { Avatar } from './Avatar';

export const HeaderNavToolsBox: FC<HeaderNavToolsBoxProps> = ({
  avatarProps,
  isHidden = false,
  showSystemLinks = true,
  showTechnicalSupport = true,
}) => {
  const hasChosenStudy = useSelector(isLoggedInSelector);
  const canViewMyProfile = useCanViewMyProfile();
  const hideMyProfile = !canViewMyProfile;

  if (isHidden) {
    return null;
  } else {
    return (
      <FlexRow>
        {hasChosenStudy && (
          <>
            <PermissionCheckComponent permission={PermissionType.CAN_VIEW_PATIENTS} fallback={null}>
              <BarcodeInputContainer />
            </PermissionCheckComponent>
            {showTechnicalSupport && (
              <PermissionCheckComponent permission={PermissionType.CAN_VIEW_SUPPORT_SECTION} fallback={null}>
                <TechnicalSupportDrawerContainer />
              </PermissionCheckComponent>
            )}
            {showSystemLinks && (
              <PermissionCheckComponent permission={PermissionType.CAN_VIEW_SYSTEM_LINKS} fallback={null}>
                <SystemLinksDrawerContainer />
              </PermissionCheckComponent>
            )}
          </>
        )}
        <Avatar hideMyProfile={hideMyProfile} {...avatarProps} />
      </FlexRow>
    );
  }
};
